import { cx } from '@linaria/core';
import { radioButtonMediaInput } from '@utils/component-framework';
import { useOpgavekompleksetEntry } from '../../../../state/hook.entry.js';
import { useUpdateTaskEntryMutation } from '../../../../state/mutations/update-task-entry.js';
import { CircledAudioPlayer } from '../../../atom.audio/_audio-player.circled.js';
import { useInputState } from '../../hook.use-input-state.js';
import { MediaBox } from '../atom.media-box/_media-box.js';
import { player, box } from './input.audio.style.js';
import { jsx } from 'react/jsx-runtime';

function AudioInput(props) {
  const update = useUpdateTaskEntryMutation();
  const inputEntry = useOpgavekompleksetEntry({
    select: entry => radioButtonMediaInput.entry.asType(entry?.data.tasks[props.taskEntryKey]?.details[props.node.id])
  });
  const onChange = () => {
    update(props.taskEntryKey, prev => {
      const next = Object.fromEntries(Object.entries(prev ?? {}).filter(([, value]) => value.type !== "radio-button-media" || value.taskId !== props.taskId));
      return {
        ...next,
        [props.node.id]: {
          type: "radio-button-media",
          taskId: props.taskId,
          markedAsCorrectAnswer: !inputEntry?.markedAsCorrectAnswer
        }
      };
    });
  };
  const baseState = useInputState(props.node, inputEntry, {
    forceValidation: (node, entry) => !!entry?.markedAsCorrectAnswer
  });
  const state = (() => {
    if (baseState === "incorrect" && !inputEntry?.markedAsCorrectAnswer && props.node.correctAnswer) {
      return "should-have";
    }
    return baseState;
  })();
  return /*#__PURE__*/jsx(MediaBox, {
    className: cx(box, props.orientation),
    checked: !!inputEntry?.markedAsCorrectAnswer,
    state: state,
    onChange: onChange,
    orientation: props.orientation,
    theme: "rounded",
    children: /*#__PURE__*/jsx(CircledAudioPlayer, {
      size: "large",
      className: player,
      src: props.node.src
    })
  });
}

export { AudioInput };
//# sourceMappingURL=input.audio.js.map
